import React from 'react';
import PropTypes from 'prop-types';

const ServiceCard = ({ icon, title, description }) => (
  <div className="service-card-horizontal">
    <div className="service-card-horizontal-content">
      <h3 className="service-card-title">{title}</h3>
      <p className="service-card-desc">{description}</p>
    </div>
    <div className="service-card-horizontal-icon">
      {icon}
    </div>
  </div>
);

ServiceCard.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default ServiceCard; 